const PRODUCTION_DOMAIN = "participa.blockchaintools.cat";
const isProduction = typeof window !== 'undefined' && window.location.hostname === PRODUCTION_DOMAIN;
export const API_URL = isProduction ? "" : (process.env.REACT_APP_BACKEND_URL || "");
